import { useToolbarMetricsStore } from "@amzn/aws-euc-ui";
import { useSessionDataStore } from "./useSessionDataStore";
import { useEffect } from "react";
import log, { TOOLBAR_METRIC_NAME } from "../logging";
import { useToolbarPreferenceStore } from "./useToolbarPreferenceStore";

export const useEmitSessionMetrics = (sessionEnded: boolean): void => {
  const {
    collapsedDuration,
    collapseButtonClickCount,
    collapseHandleClickCount,
    expandButtonClickCount,
    expandHandleClickCount,
  } = useToolbarMetricsStore();
  const sessionStartTime = useSessionDataStore(
    (store) => store.sessionStartTime
  );
  const microphoneEnabledDuration = useSessionDataStore(
    (store) => store.microphoneEnabledDuration
  );
  const microphoneEnabled = useToolbarPreferenceStore(
    (store) => store.microphoneEnabled
  );
  const microphoneLastEnabledTime = useSessionDataStore(
    (store) => store.microphoneLastEnabledTime
  );

  useEffect(() => {
    if (sessionEnded) {
      if (sessionStartTime !== undefined) {
        const sessionEndTime = performance.now();
        const sessionDuration = (sessionEndTime - sessionStartTime) / 1000;

        // Emit toolbar expanded ratio metric
        const toolbarExpandedDuration = sessionDuration - collapsedDuration;
        const toolbarExpandedRatio =
          (toolbarExpandedDuration / sessionDuration) * 100;
        log.publishRatioMetric(
          TOOLBAR_METRIC_NAME.TOOLBAR_EXPANDED_DURAION_RATIO,
          toolbarExpandedRatio
        );

        // Emit microphone enabled duration ratio metric
        let microphoneEnabledDurationRatio: number;
        // If microphone is enabled when user ends session, add the duration from the last time it was enabled to the total duration
        if (microphoneEnabled) {
          const microphoneEnabledDurationTotal =
            microphoneEnabledDuration +
            (sessionEndTime - microphoneLastEnabledTime) / 1000;
          microphoneEnabledDurationRatio =
            (microphoneEnabledDurationTotal / sessionDuration) * 100;
        } else {
          microphoneEnabledDurationRatio =
            (microphoneEnabledDuration / sessionDuration) * 100;
        }
        log.publishRatioMetric(
          TOOLBAR_METRIC_NAME.MICROPHONE_ENABLED_DURATION_RATIO,
          microphoneEnabledDurationRatio
        );
      }

      // Emit toolbar button click count metrics
      log.publishCounterMetric(
        TOOLBAR_METRIC_NAME.EXPAND_BUTTON_CLICK_COUNT,
        expandButtonClickCount
      );
      log.publishCounterMetric(
        TOOLBAR_METRIC_NAME.EXPAND_HANDLE_CLICK_COUNT,
        expandHandleClickCount
      );
      log.publishCounterMetric(
        TOOLBAR_METRIC_NAME.COLLAPSE_BUTTON_CLICK_COUNT,
        collapseButtonClickCount
      );
      log.publishCounterMetric(
        TOOLBAR_METRIC_NAME.COLLAPSE_HANDLE_CLICK_COUNT,
        collapseHandleClickCount
      );
    }
  }, [sessionEnded]);
};
